import React, { Component, useState } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as moment from 'moment';
import { Link } from 'react-router-dom';
import voca from 'voca';
import CustomLoader from '../common/CustomLoader';
import * as actions from './redux/actions';
import ItemTableRow from './item/itemTable/ItemTableRow';
import ItemListHeading from './item/itemTable/ItemListHeading';
import {
  COLLECTION_ITEM,
  RECORD,
  filterFieldsForItemList,
  filterSystemCreatedFieldsForItemList,
} from 'drapcode-constant';
import { filterUserCreatedFieldsForItemList } from '../common/FieldTypes';
import ParentDocCard from '../common/ParentDocCard';
import CustomReactPaginate from '../../common/custom/CustomReactPaginate';
import { collectionItemText } from '../../common/docs/content';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import AdvanceCollectionOptions from './AdvanceCollectionOptions';
import { ParentContentCardMultiHeader } from '../common/ParentContentCardMultiHeader';
import showAlert from '../../common/utils/alert';
import DocsLink from '../../common/custom/DocsLink';
import AlertMessageBox from '../../common/ui/AlertMessageBox';
import { prepS3Url } from '../../common/utils/plugin_utils';
import CollectionItemsTable from './CollectionItemsTable';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Form, Formik, Field } from 'formik';
import CustomInputWithIconNoFormGroup from '../../common/ui/CustomInputWithIconNoFormGroup';
import CustomSelect from '../home/collections/CustomSelect';
import { BASE_AI_MODELS, createRedirectUrl } from '../../common/utils/prompt-constants';
import { builderSurfaceJsonContentHeader } from '../../common/utils/restApiHeaderUtils';
import { toast } from 'react-toastify';
import { to } from 'mathjs';

const configCss = {
  maxWidth: '50%',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
};
export class CollectionItems extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    isOpenImportModal: false,
    page: 0,
    limit: 25,
    searchTerm: '',
    openDataModal: false,
  };

  triggerLoadCollectionItems = (page, searchTerm = '', sortData) => {
    const { match, actions } = this.props;
    const { projectId, collectionName, version } = match.params;
    const { limit } = this.state;
    const query = { projectId, collectionName, page, limit, version };
    if (searchTerm) {
      query.searchTerm = searchTerm;
    }
    if (sortData && sortData.length > 0) {
      const { sortField, sortOrder } = sortData[0];
      (query.sortField = sortField), (query.sortOrder = sortOrder);
    }
    actions.loadCollectionItems(query);
  };

  componentDidMount() {
    const { projectId, collectionId, version } = this.props.match.params;
    this.props.actions.loadProjectCollectionDetail({ projectId, collectionId, version });
    this.triggerLoadCollectionItems(this.state.page);
    this.props.actions.getPermissionFlags({ projectId });
  }

  shouldComponentUpdate = (nextProps, nextState, nextContext) => {
    if (nextProps.match.url !== this.props.match.url) {
      const { projectId, collectionId, collectionName, version } = nextProps.match.params;
      nextProps.actions.loadProjectCollectionDetail({ projectId, collectionId, version });
      nextProps.actions.loadCollectionItems({
        projectId,
        collectionName: collectionName,
        page: this.state.page,
        limit: this.state.limit,
        version,
      });
    }
    return true;
  };

  openImportModal = () => {
    this.setState({ isOpenImportModal: true });
  };
  hideModal = () => {
    this.setState({ isOpenImportModal: false });
  };
  updateSearchTerm = (value, e) => {
    this.setState({ searchTerm: value, page: 0 });
  };
  handleSearch = () => {
    const { collections, match } = this.props;
    const {
      selectedCollection: { collectionName },
    } = collections;
    const { projectId, version } = match.params;
    const { searchTerm, page } = this.state;
    if (collectionName) {
      this.triggerLoadCollectionItems(page, searchTerm);
    }
  };

  refreshRecords = () => {
    this.triggerLoadCollectionItems(this.state.page);
  };

  deleteAllItems = () => {
    const { match, actions } = this.props;
    const { projectId, collectionName, version } = match.params;
    const preConfirm = async () => {
      actions.deleteAllItems({
        projectId,
        version,
        collectionName,
      });
    };
    const message =
      "This action will delete all items of collection. You won't be able to revert this.";
    showAlert(message, preConfirm, 'Yes, delete it!');
  };

  itemDataJSON = (fields) => {
    let systemCreatedFields = filterSystemCreatedFieldsForItemList(fields);
    let userCreatedFields = filterUserCreatedFieldsForItemList(fields);
    let userAndSystemCreatedFields = [...userCreatedFields, ...systemCreatedFields];
    let itemData = [];
    let itemTemp = {};
    userAndSystemCreatedFields.forEach((element) => {
      itemTemp[element.fieldName] = `REPLACE_${element.fieldName}_HERE`;
    });
    for (let i = 0; i < 3; i++) {
      itemData.push(itemTemp);
    }
    return itemData;
  };

  templateFile = (collectionTitle) => {
    let fileName = 'Template';
    let templateTimestamp = moment().format('YYYY-MM-DD-HH-mm-ss-SSS');
    fileName = `${fileName}${templateTimestamp}`;
    if (collectionTitle) {
      fileName = `${collectionTitle}${fileName}`;
    }
    return fileName;
  };

  //todo need to remove after testing
  renderCollectionData = (userAndSystemCreatedFields) => {
    const { collections, actions, match, home, common } = this.props;
    const { projectId, version } = match.params;
    const { items, selectedCollection, permissionFlags } = collections;
    let permissionsArray = [];
    if (permissionFlags && permissionFlags.length > 0) {
      permissionsArray = permissionFlags || [];
    }

    if (!items || !items.length) {
      return (
        <tr>
          <td
            colSpan={userAndSystemCreatedFields && userAndSystemCreatedFields.length + 1}
            className="pl-5 align-middle text-center"
          >
            No Data!
          </td>
        </tr>
      );
    }

    const { iPlugins } = home;
    const s3Url = prepS3Url(iPlugins, common.projectDetail, false);
    return (
      <>
        {items.map((item, i) => (
          <ItemTableRow
            key={i}
            item={item}
            fields={userAndSystemCreatedFields}
            actions={actions}
            selectedCollection={selectedCollection}
            projectId={projectId}
            version={version}
            iPlugins={iPlugins}
            s3Url={s3Url}
            flag={permissionsArray.includes(COLLECTION_ITEM)}
          />
        ))}
      </>
    );
  };

  openDataModal = () => {
    this.setState({ openDataModal: true });
  };

  toggleOpenDataModal = () => {
    this.setState({ openDataModal: !this.state.openDataModal });
  };

  handleSubmit = async (values) => {
    this.setState({ openDataModal: !this.state.openDataModal });
    await this.generateCollectionData(values);
  };

  generateCollectionDataView = () => {
    const { collections, match } = this.props;
    const { projectId, version } = match.params;
    const projectDetail = collections.projectDetail || {};
    const { selectedAIModel } = this.state;
    const extractCollectionDataPending = collections.extractCollectionDataPending;
    let hasEnabledAIModelConfigs = false;
    let modelOptions = [];
    let defaultAIModelValue = null;
    if (projectDetail.aiModelConfigs) {
      const enabledConfigs = projectDetail.aiModelConfigs.filter((cfg) => cfg.isEnabled);
      if (enabledConfigs.length > 0) {
        hasEnabledAIModelConfigs = true;
        const defaultConfig = enabledConfigs.find((cfg) => cfg.isDefault);
        if (defaultConfig) {
          const base = BASE_AI_MODELS.find((opt) => opt.value === defaultConfig.modelType);
          defaultAIModelValue = {
            label: base.label || defaultConfig.modelType,
            value: defaultConfig.modelType,
          };
          if (defaultAIModelValue && !this.state.selectedAIModel) {
            this.setState({ selectedAIModel: defaultAIModelValue.value });
          } 
        }
        modelOptions = enabledConfigs.map((cfg) => {
          const base = BASE_AI_MODELS.find((opt) => opt.value === cfg.modelType);
          return {
            label: base.label || cfg.modelType,
            value: cfg.modelType,
          };
        });
      }
    }

    let redirectUrl = createRedirectUrl();
    let aiModelConfigurationURL = `${redirectUrl}app-setting/${version}/v/${projectId}/setting/aiModelConfig-section`;

    const numberOfRecordsOptions = [5, 10, 15, 20, 25].map((num) => ({
      label: `${num}`,
      value: num,
    }));

    return (
      <div className="form-horizontal position-relative">
        <Formik enableReinitialize initialValues={{ aiModel: defaultAIModelValue }}>
          {({ values, setFieldValue }) => (
            <Form>
              <div className="form-group mb-3 position-relative z-3">
                <label className="mb-0">Select AI Model</label>
                <CustomInputWithIconNoFormGroup icon="dropdown" title="Select AI Model" required>
                  <CustomSelect
                    name="aiModel"
                    isMulti={false}
                    options={modelOptions}
                    value={values.aiModel}
                    onChange={(_, value) => {
                      const sel = value ? value : null; 
                      setFieldValue('aiModel', sel);
                      this.setState({ selectedAIModel: sel ? sel.value : '' });
                    }}
                    menuPlacement="top"
                    classNamePrefix="select"
                  />
                </CustomInputWithIconNoFormGroup>
              </div>

              <div className="form-group mb-3 position-relative z-3">
                <label className="mb-0">Number of Records</label>
                <CustomInputWithIconNoFormGroup
                  icon="dropdown"
                  title="Select Number of Records"
                  required
                >
                  <CustomSelect
                    name="noOfRecords"
                    isMulti={false}
                    options={numberOfRecordsOptions}
                    value={
                      numberOfRecordsOptions.find((opt) => opt.value === values.noOfRecords) || null
                    }
                    onChange={(_, value) => {
                      const val = value ? value.value : 5;
                      setFieldValue('noOfRecords', val);
                    }}
                    menuPlacement="top"
                    classNamePrefix="select"
                  />
                </CustomInputWithIconNoFormGroup>
              </div>

              {!hasEnabledAIModelConfigs && (
                <div className="text-danger mt-2 ml-6">
                  <i className="fa fa-warning" aria-hidden="true"></i>
                  Please configure the AI model in the{' '}
                  <a
                    href={aiModelConfigurationURL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-style"
                  >
                    AI Model Configuration{' '}
                    <i className="fa fa-external-link" aria-hidden="true"></i>
                  </a>
                  section.
                </div>
              )}
              {extractCollectionDataPending && (
                <div className="text-dark text-center mb-3">Generating records Please wait...</div>
              )}

              <div className="col-md-12 col-lg-12 text-right">
                <button
                  type="button"
                  className={`btn btn-xs ${
                    extractCollectionDataPending ? 'btn-default' : 'btn-theme-submit'
                  }`}
                  onClick={async () => {
                    try {
                      const extractedData = await this.generateCollectionDataCreate(
                        values.noOfRecords,
                      );
                      if (extractedData) {
                        await this.generateCollectionData(extractedData);
                      }
                    } catch (error) {
                      console.error('Error generating collection data:', error);
                    }
                  }}
                  disabled={
                    !selectedAIModel ||
                    !hasEnabledAIModelConfigs ||
                    !values.noOfRecords ||
                    extractCollectionDataPending
                  }
                >
                  <i className="wb webconnect-save" />
                  &nbsp;Generate and Save Records
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    );
  };

  generateCollectionDataCreate = async (noOfRecords) => {
    const { actions, codeGenerationModel, collections, match } = this.props;
    const { projectId, collectionName, collectionId, version } = match.params;
    const projectDetail = collections.projectDetail || {};
    const selectedModelType = this.state.selectedAIModel || 'OPEN_AI';
    const aiModelConfig =
      (projectDetail.aiModelConfigs || []).find((cfg) => cfg.modelType === selectedModelType) || {};
    const apiKey = aiModelConfig.setting.secretKey || '';
    const modelType = aiModelConfig.setting.modelType || selectedModelType;
    const numberOfRecords = noOfRecords.toString();
    const header = builderSurfaceJsonContentHeader(projectId);
    let environment;
    if (header && header.headers && header.headers['x-project-env']) {
      environment = header.headers['x-project-env'];
    }
    try {
      const extractedData = await actions.extractCollectionData({
        collectionId,
        codeGenerationModel: codeGenerationModel || '',
        projectId,
        collectionName,
        version,
        apiKey,
        aiModel: modelType,
        generatedCodeConfig: 'create_collection_data',
        numberOfRecords,
        environment,
      });
      this.setState({
        openDataModal: true,
      });
      console.log('Extracted Data:', extractedData);

      return extractedData.data[0];
    } catch (error) {
      toast.error("error while generating data");
      console.error('Error extracting collection data:', error);
      throw error;
    }
  };

  generateCollectionData = async (extractedData) => {
    const { actions, match } = this.props;
    const { projectId, collectionName, version } = match.params;
    try {
      const savedData = await actions.generateCollectionData({
        projectId,
        collectionName,
        version,
        body: extractedData,
      });
      this.setState({ savedData, openDataModal: false }, () => {
        this.refreshRecords();
      });
    } catch (error) {
      console.error('Error generating collection data:', error);
    }
  };

  renderCollectionItem = () => {
    const { collections, actions, match, home, common, extractCollectionDataPending } = this.props;
    const { projectId, collectionId, collectionName, version } = match.params;
    console.log('1');
    const {
      selectedCollection,
      totalItemPages,
      loadProjectCollectionDetailPending,
      loadCollectionItemsPending,
      totalItems,
      permissionFlags,
      items,
    } = collections;
    let allRecordsFlag;

    let permissionsArray = [];
    if (permissionFlags && permissionFlags.length > 0) {
      permissionsArray = permissionFlags || [];
    }

    const { iPlugins } = home;
    const s3Url = prepS3Url(iPlugins, common.projectDetail, false);

    if (loadProjectCollectionDetailPending) {
      console.log('3');
      return (
        <div className="text-center">
          <CustomLoader loading={loadProjectCollectionDetailPending} size="20px" color="#303453" />
        </div>
      );
    } else if (selectedCollection) {
      let { fields, collectionTitle, restrictItem } = selectedCollection;
      fields = filterFieldsForItemList(fields);

      let systemCreatedFields = filterSystemCreatedFieldsForItemList(fields);
      let userCreatedFields = filterUserCreatedFieldsForItemList(fields);
      let userAndSystemCreatedFields = [...userCreatedFields, ...systemCreatedFields];
      let itemData = this.itemDataJSON(fields);
      const { searchTerm, page, openDBDump, limit } = this.state;
      return (
        <div className="row mx-auto">
          <ParentContentCardMultiHeader
            isEnvironment
            isSearch
            btnSize="sm"
            totalItems={totalItems}
            handleSearch={this.handleSearch}
            updateSearchTerm={this.updateSearchTerm}
            projectId={projectId}
            version={version}
            title={`${collectionTitle ? collectionTitle : 'Collection'}'s Data`}
            icon="collection"
            bgColor="drapcode-violet"
            refreshMethod={() => {
              this.triggerLoadCollectionItems(page, searchTerm);
            }}
            CtaComponent={
              <>
                <Link
                  to={`/collections/${version}/v/${projectId}/edit/${collectionId}`}
                  className="btn btn-primary btn-md mr-2"
                  title={collectionTitle ? `Configure ${collectionTitle}` : 'Configure Collection'}
                  style={configCss}
                >
                  <i className="wb webconnect-cog"></i>&nbsp;Configuration
                </Link>

                <AdvanceCollectionOptions
                  projectId={projectId}
                  version={version}
                  collectionId={collectionId}
                  collectionTitle={collectionTitle}
                  itemData={itemData}
                  filename={this.templateFile(collectionTitle)}
                  deleteAllItems={this.deleteAllItems}
                  flag={permissionsArray.includes(RECORD)}
                />
                {restrictItem ? (
                  ''
                ) : (
                  <Link
                    to={`/collections/${version}/v/${projectId}/${collectionId}/items/create`}
                    className="btn btn-theme-submit btn-md mr-2"
                    title={`Add New Data in ${collectionTitle ? collectionTitle : 'Collection'}`}
                    style={configCss}
                  >
                    <i className="wb webconnect-plus"></i> Add&nbsp;
                    {voca.truncate(collectionTitle ? collectionTitle : 'Collection', 15)}
                  </Link>
                )}
                <button
                  type="button"
                  className="btn btn-primary btn-md mr-2"
                  onClick={() => {
                    this.generateCollectionDataView();
                    this.openDataModal();
                  }}
                  disabled={extractCollectionDataPending}
                >
                  <i className="wb webconnect-arrow-down-circle-fill"></i> Generate Data&nbsp;
                </button>
                <Modal
                  isOpen={this.state.openDataModal}
                  toggle={this.toggleOpenDataModal}
                  backdrop="static"
                  size="lg"
                >
                  <ModalHeader toggle={this.toggleOpenDataModal} className="border-bottom">
                    AI Generated Data
                  </ModalHeader>
                  <ModalBody>{this.generateCollectionDataView()}</ModalBody>
                </Modal>
                <button
                  type="button"
                  className="btn btn-default btn-md"
                  title={
                    collectionTitle ? `Refresh ${collectionTitle}` : 'Refresh Collection Records'
                  }
                  onClick={() => this.refreshRecords()}
                >
                  <i className="wb webconnect-refresh" />
                </button>
              </>
            }
          >
            {loadCollectionItemsPending ? (
              <div className="text-center">
                {' '}
                <CustomLoader loading={loadCollectionItemsPending} size="20px" color="#303453" />
              </div>
            ) : (
              <div className="row">
                <div className="col-md-12 col-lg-12">
                  <CollectionItemsTable
                    fields={userAndSystemCreatedFields}
                    items={items}
                    actions={actions}
                    selectedCollection={selectedCollection}
                    projectId={projectId}
                    version={version}
                    flag={permissionsArray.includes(COLLECTION_ITEM)}
                    iPlugins={iPlugins}
                    s3Url={s3Url}
                    limit={limit}
                    totalPages={totalItemPages}
                    page={this.state.page}
                    totalItems={totalItems}
                    searchTerm={this.state.searchTerm}
                    handleSortingChangeCheck={this.handleSortingChange}
                  />
                </div>
              </div>
            )}
          </ParentContentCardMultiHeader>
        </div>
      );
    } else {
      return '';
    }
  };

  showAlertMessage = () => {
    return (
      <AlertMessageBox
        type="info"
        text={'Note: Data persistence is not permitted for Non-persistent collections.'}
      />
    );
  };

  renderNonPersistent = () => {
    const { collections, match } = this.props || {};
    const { selectedCollection } = collections || {};
    const { collectionTitle } = selectedCollection || {};
    const { projectId, version } = match.params || {};

    return (
      <div className="row mx-auto">
        <ParentContentCardMultiHeader
          btnSize="sm"
          projectId={projectId}
          version={version}
          title={`${collectionTitle ? collectionTitle : 'Collection'}'s Data`}
          icon="collection"
          bgColor="drapcode-violet"
        >
          {this.showAlertMessage()}
        </ParentContentCardMultiHeader>
      </div>
    );
  };

  render() {
    // console.log('here is props collection items', this.props);
    //TODO: Need to Handle Non-Persistent Collection Item Data accessibility
    // const { collections } = this.props;
    // const { selectedCollection } = collections || {};
    // let showCollectionItems = true;
    // if (selectedCollection) {
    //   const { willPersist, externalDatabaseId } = selectedCollection ? selectedCollection : '';
    //   showCollectionItems = willPersist && !externalDatabaseId ? true : false;
    // }
    //TODO: Need refactoring to fix multiple rendering issue
    return (
      <CommonPageComponent parentClassName="collections-collection-edit">
        {/* {showCollectionItems ? this.renderCollectionItem() : this.renderNonPersistent()} */}
        {this.renderCollectionItem()}
        <ParentDocCard>
          <h5>
            <b>Introduction to collections</b>
          </h5>
          <p>
            DrapCode not only helps you build a no code front end but also offers you a no code
            inbuilt database for your web applications through collections, in which data can be
            stored manually as well as dynamically.
          </p>
          <DocsLink link="https://academy.drapcode.com/docs/app-collection/introduction-to-collections" />
          <br />
          <h5>
            <b>Create collection</b>
          </h5>
          <p>
            Creating a Collection in DrapCode is a straightforward process. Remember, a collection
            is a secure and organized way to store your data of any kind, which can be reused again
            and again very conveniently.
          </p>
          <DocsLink link="https://academy.drapcode.com/docs/app-collection/create-collection/" />
          <br />
          <h5>
            <b>Manage collection</b>
          </h5>
          <p>
            After creating a collection, you can easily add as many fields in it, edit or delete
            them as you want.
          </p>
          <DocsLink link="https://academy.drapcode.com/docs/app-collection/manage-collection" />
        </ParentDocCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
    home: state.home,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CollectionItems);
